export default __webpack_public_path__ + "static/media/argentina-icon.b88cb900.svg";